import {extendObservable, action, toJS} from 'mobx';

class Printers {
  constructor() {
    extendObservable(this, {
      _printers: [],
      fetching: false,
      error: undefined,

      setPrinters: action(printers => {
        this._printers = printers
      }),

      get items() {
        return toJS(this._printers)
      }

    })
  }
}

export default new Printers()
